module.exports = __webpack_public_path__ + "static/media/heart.5adf0fe7.svg";